import styled from 'styled-components/macro';
import { Images } from 'assets/images';
import { size } from 'assets/styles/ScreenSize';
import {
  COLORS,
  FLEX_CONTAINER,
  FONT_FAMILY,
  FONTS,
  BREAKPOINTS,
} from 'utils/styles';

export const ContentContainer = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};
  justify-content: center;
  gap: 40px;
  width: 100%;
  height: 800px;
  background-image: url(${Images.popularPlaces});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-left: 200px;
  padding-right: 200px;
  overflow: hidden;

  @media only screen and (max-width: ${size.desktop}) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media only screen and (max-width: 1280px) {
    ${FLEX_CONTAINER.FlexCenterColumn};
  }
`;

export const CardWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};
  justify-content: center;
  width: 100%;
  gap: 100px;

  @media only screen and (max-width: ${size.laptopL}) {
    ${FLEX_CONTAINER.FlexCenterColumn};
  }

  @media only screen and (max-width: ${size.laptopL}) {
    width: auto;
    display: block;
  }
  @media ${BREAKPOINTS.md} {
    width: 100%;
  }
`;

export const OurHotOffers = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  width: 400px;
  height: 200px;

  @media only screen and (max-width: ${size.desktop}) {
    width: 300px;
  }
`;

export const GlobusContainer = styled.div`
  position: relative;
  width: 173px;
  height: 160px;
  background: url(${({ globusImg }) => globusImg && globusImg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media only screen and (max-width: ${size.laptopL}) {
    width: 122px;
    height: 112px;
  }
`;

export const GlobusImage = styled.img`
  position: absolute;
  top: 102px;

  @media only screen and (max-width: ${size.laptopL}) {
    display: none;
  }
`;

export const OurHotOffersForYou = styled.span`
  ${FONTS.font36};
  ${FONT_FAMILY.FontBold};
  color: ${COLORS.mainColor};
  text-align: center;
  text-transform: capitalize;

  @media only screen and (max-width: ${size.desktop}) {
    ${FONTS.font24};
  }
`;

export const OurHotOffersYellow = styled.span`
  color: ${COLORS.yellow};
  ${FONT_FAMILY.FontBold};
`;

export const SliderContainer = styled.div`
  width: 750px;
  padding-bottom: 40px;

  .swiper-pagination {
    bottom: 0 !important;
    text-align: start;
    left: 112px !important;

    @media only screen and (max-width: ${size.mobileL}) {
      display: none !important;
    }

    @media only screen and (max-width: ${size.laptopL}) {
      left: 0 !important;
      text-align: center !important;
    }
  }

  .swiper-pagination-bullet-active {
    background: ${COLORS.mainColor} !important;
  }
`;
